import { render, staticRenderFns } from "./StatGroupManagement.vue?vue&type=template&id=034d8bee"
import script from "./StatGroupManagement.vue?vue&type=script&lang=js"
export * from "./StatGroupManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports